import { Component, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';

import { Subscription } from 'rxjs';
import { ReportPageInterface } from 'src/app/interface';
import { FieldValue, FieldValueReset, Report } from 'src/app/model';
import { FooterButtonOption, PageNumbers } from 'src/app/model/Enums';
import { ReportProvider } from 'src/app/providers';
import { ReportService, ToasterService } from 'src/app/services';
import { radioGroupOption } from '../../commonModel/common-classes';

@Component({
  selector: 'app-special-consideration',
  templateUrl: './special-consideration.component.html',
  styleUrls: ['./special-consideration.component.scss']
})
export class SpecialConsiderationComponent implements OnInit, OnDestroy, ReportPageInterface {

  public currentReport: Report;
  private reportSub: Subscription;

  @ViewChild('specialForm') specialForm: NgForm;

  // Question 1: covid-impact
  effectList: radioGroupOption[] = [];
  monthList: radioGroupOption[] = [];

  // Question 2: service-type
  serviceList: radioGroupOption[] = [];

  yesNo_Option: radioGroupOption[] = [];

  constructor(private reportService: ReportService,
    private reportProvider: ReportProvider,
    private router: Router,
    private toastr: ToasterService) { }

  ngOnInit(): void {

    // Question 1: covid-impact
    this.effectList.push({ title: 'Negatively Impacted', value: true });
    this.effectList.push({ title: 'Not Negatively Impacted', value: false });
    for (let i = 1; i <= 12; i++) {
      const optObject = new radioGroupOption();
      optObject.title = i.toString();
      optObject.value = i;
      this.monthList.push(optObject);
    }

    // Question 2: service-type
    this.serviceList.push({ title: 'Essential', value: true });
    this.serviceList.push({ title: 'Nonessential', value: false });

    // Question 3: closures-restrictions
    // Question 4: additional-debt
    this.yesNo_Option.push({ title: 'Yes', value: true });
    this.yesNo_Option.push({ title: 'No', value: false });

    this.reportSub = this.reportService.report$.subscribe(currentReport => {
      this.currentReport = currentReport;
    });
  }

  ngOnDestroy(): void {
    if (this.reportSub)
      this.reportSub.unsubscribe();
  }

  /**
   * @description field update API
   * @param fieldName field name which we want to update
   */
  callUpdateAPI(fieldName: string) {
    let objFieldValue = new FieldValue();
    objFieldValue.GROUP = 'REPORT_VERSION';
    objFieldValue.FIELD = fieldName;
    objFieldValue.VALUE = this.currentReport.LATEST[fieldName];
    this.reportProvider.updateReportField(this.currentReport.LATEST.ID, objFieldValue).subscribe(res => {
      if (!res.success) {
        this.toastr.error(res.error.txt);
      }
    }, err => {
      // Error Handling
    });
  }

  /**
   * @description for reset selected options
   */
  resetFieldAPI() {
    let objFieldValueReset = new FieldValueReset();
    objFieldValueReset.GROUP = 'REPORT_VERSION';
    objFieldValueReset.FIELD_LIST = ['COVID_AFFECTED', 'COVID_MONTHS', 'COVID_ESSENTIAL', 'COVID_RESTRICTIONS', 'COVID_ADD_DEBT'];
    this.reportProvider.resetReportField(this.currentReport.LATEST.ID, objFieldValueReset).subscribe(res => {
      if (!res.success) {
        this.toastr.error(res.error.txt);
      }
    }, err => {
      // Error Handling
    });
  }

  /**
       * @description for scroll focuse on inputs
       * @param $event key down
       */
  @HostListener('window:keyup', ['$event'])
  onKeyPress($event: KeyboardEvent) {
    if ($event.keyCode == 9) {
      const elePosition = document.activeElement.getBoundingClientRect();
      if (window.innerHeight - 115 < elePosition.y) {
        document.activeElement.scrollIntoView(true);
      }
    }
  }

  /**
   * @description function of interface for validation
   * @returns form valid or not
   */
  isFormValid(): boolean {
    return this.specialForm.valid;
  }

  /**
   * @description function of interface for skip functionality
   * @returns form can be skippable or not
   */
  canBeSkipped(): boolean {
    return false;
  }

  /**
   * @description report footer button click options
   * @param buttonOption which button clicked by user
   */
  footerButtonClick(buttonOption: number) {
    if (buttonOption == FooterButtonOption.NEXT_CLICK) {
      this.reportService.updateMaxStage(PageNumbers.SPECIAL_CONSIDERATION);
      this.router.navigateByUrl(`/report/${this.currentReport.ID}/location`);
      // comment for alternative flow
      // if (this.reportService.showLocationAmountPage()) {
      //   this.router.navigateByUrl(`/report/${this.currentReport.ID}/location/location-amount`);
      // } else {
      //   this.router.navigateByUrl(`/report/${this.currentReport.ID}/location/location-details`);
      // }
    } else if (buttonOption == FooterButtonOption.BACK_CLICK) {
      this.reportService.updateMaxStage(PageNumbers.SPECIAL_CONSIDERATION);
      // comment for alternative flow
      // this.router.navigateByUrl(`/report/${this.currentReport.ID}/overview/transaction-type`);
      this.router.navigateByUrl(`/report/${this.currentReport.ID}/overview`);
    }
  }

}
